var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-page"},[_c('img',{staticClass:"no-page-404",attrs:{"src":require("../assets/images/404.png"),"alt":""}}),_c('div',{staticClass:"no-page-font"},[_vm._v("页面已失效，试试重新进入页面吧")])])
}]

export { render, staticRenderFns }